import React from "react";
import { useDispatch } from "react-redux";
import { ClearFilters } from "../../components/filters/ClearFilters";
import { ClientsFilter } from "../../components/filters/ClientsFilter";
import { Filters } from "../../components/filters/Filters";
import { LocationsFilter } from "../../components/filters/LocationsFilter";
import { NavButtons } from "../../components/navigation/NavButtons";
import { SearchResultsCount } from "@greco/components";
import { NavigationBar, Right } from "../../components/styled";
import { setClientsFilter } from "../../store/filters/filters";
import { useSelector } from "../../store/hooks";
import { Search } from "./Search";
import { useTranslation } from "react-i18next";
import { setManageLocationsDialog } from "../../store/users";
import { setManageReportsDialog } from "../../store/usersinsurer";
import { Checkbox, CommandBarButton } from "@fluentui/react";
import { setShowActiveReportsOnly } from "../../store/reports-page/reportsPage";
import { ExportMenu } from "./ExportMenu";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Report } from "../../types/types";
import styled from "styled-components";

type Props = {
  refExcelExport?: ExcelExport;
  filteredReports?: Report[];
  visibleLabelKeys?: string[];
  onOpenColumnOptions?: () => void;
  activeFilterCount?: number;
  filteredCount?: number;
};

export const Navigation = ({
  refExcelExport,
  filteredReports,
  visibleLabelKeys,
  onOpenColumnOptions,
  activeFilterCount = 0,
  filteredCount,
}: Props) => {
  const reduxCount = useSelector((s) => s.reportsPage.shownIds.length);
  const count = filteredCount !== undefined ? filteredCount : reduxCount;
  const showActiveReportsOnly = useSelector(
    (s) => s.reportsPage.showActiveReportsOnly,
  );
  const dispatch = useDispatch();
  const clientsFilter = useSelector((s) => s.filters.clientsFilter);
  const locationsFilter = useSelector((s) => s.filters.locationsFilter);
  const { t } = useTranslation();

  return (
    <NavigationBar>
      <NavButtons />
      <Search />
      <Filters>
        <ClientsFilter />
        <LocationsFilter />
        <Checkbox
          label={t("ram.reports.showActiveOnly.label")}
          checked={showActiveReportsOnly}
          onChange={() => {
            dispatch(setShowActiveReportsOnly(!showActiveReportsOnly));
          }}
        />
        <ClearFilters
          isDisabled={
            clientsFilter.length === 0 && locationsFilter.length === 0
          }
          onClear={() => {
            dispatch(setClientsFilter([]));
            dispatch(
              setManageLocationsDialog({
                user: null,
                isOpen: false,
              }),
            );
            dispatch(
              setManageReportsDialog({
                user: null,
                isOpen: false,
              }),
            );
          }}
        />
      </Filters>
      {refExcelExport && filteredReports && (
        <ExportMenu
          refExcelExport={refExcelExport}
          filteredReports={filteredReports}
          visibleLabelKeys={visibleLabelKeys}
        />
      )}
      <Right>
        {onOpenColumnOptions && (
          <StyledCommandBarButton
            text={t("greco.columnOptions")}
            iconProps={{ iconName: activeFilterCount > 0 ? "FilterSolid" : "Filter" }}
            onClick={onOpenColumnOptions}
          />
        )}
        <SearchResultsCount count={count} label={t("greco.searchResults")} />
      </Right>
    </NavigationBar>
  );
};

const StyledCommandBarButton = styled(CommandBarButton)`
  height: 32px;
`;
